import { useRouter } from 'next/router';
import Link from 'next/link';
import React, { Children } from 'react';

const ActiveLink = ({ children, handleOpenMenu, ...props }) => {
  const router = useRouter();
  const child = Children.only(children);

  let className = child.props.className || '';

  if (router.asPath === props.href || !props?.href) {
    className = `${className} ${
      props.activeClassName ? props.activeClassName : ''
    }`.trim();
    return <span className={className}>{child.props.children}</span>;
  }

  const onClick = () => {
    handleOpenMenu?.();
  };
  return (
    <Link {...props} itemScope itemType='https://schema.org/Property'>
      {React.cloneElement(child, {
        className,
        onClick: () => onClick(),
      })}
    </Link>
  );
};

export default ActiveLink;
